import { render, staticRenderFns } from "./importaDaParcheggio.vue?vue&type=template&id=4771cee4"
import script from "./importaDaParcheggio.vue?vue&type=script&lang=js"
export * from "./importaDaParcheggio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports